@use "../../sass/global/global" as *;

.ux-iws-social-media-wall {
    display: block;
    position: relative;
    min-height: 520px;
    margin: 0 -15px;

    &__placeholder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: all 0.5;
        color: $color-black;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;

        ux-icon {
            font-size: 70px;
            color: $color-gray-copy;
            margin-bottom: 5px;
        }

        &--hidden {
            opacity: 0;
            pointer-events: none;
        }
    }

    &__content {
        display: block;
        max-width: 100%;
    }

    &__cta-wrapper {
        text-align: center;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__loading {
        margin-top: -30px;
        margin-bottom: 20px;
        height: 50px;

        ux-loader[variant="spinner"] {
            position: absolute;
        }
    }
}
